import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ProviderSickTimeComponent } from '../provider-sick-time/provider-sick-time.component';
import { ParticipantSickTimeComponent } from '../participant-sick-time/participant-sick-time.component';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import { MEMBER_VIEW_PAGE_IDS } from '../../../shared/constants/page.constants';

@Component({
  selector: 'ppl-sick-time-details',
  standalone: true,
  imports: [ProviderSickTimeComponent, ParticipantSickTimeComponent],
  templateUrl: './sick-time-details.component.html',
})
export class SickTimeDetailComponent implements OnInit {
  program: any;
  entry: any;
  isParticipantFlow = false;
  isReadOnly = false;

  constructor(
    private userService: UserService,
    private allowListStore: AllowListAuthStore
  ) {}

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry();
    this.isParticipantFlow = this.entry == 'participantEnrollment';

    const pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[pageId]) {
      this.isReadOnly = true;
    }
  }
}
